<template>
    <form class="max-w-2xl">
        <div class="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2" v-if="contact">
            <div>
                <label for="first-name" class="block text-md font-bold leading-6 text-gray-900">First name *</label>
                <div class="mt-2.5">
                    <input
                        type="text"
                        name="first-name"
                        id="first-name"
                        autocomplete="given-name"
                        :value="contact.first_name"
                        @input="(event) => updateContactField({field: 'first_name', value: event.target.value})"
                        class="block w-full rounded-md border-0 px-4 py-2.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                </div>
            </div>
            <div>
                <label for="last-name" class="block text-md font-bold leading-6 text-gray-900">Last name *</label>
                <div class="mt-2.5">
                    <input
                        type="text"
                        name="last-name"
                        id="last-name"
                        autocomplete="family-name"
                        :value="contact.last_name"
                        @input="(event) => updateContactField({field: 'last_name', value: event.target.value})"
                        class="block w-full rounded-md border-0 px-4 py-2.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                </div>
            </div>
            <div class="sm:col-span-2">
                <label for="email" class="block text-md font-bold leading-6 text-gray-900">Email *</label>
                <div class="mt-2.5">
                    <input
                        type="email"
                        name="email"
                        id="email"
                        autocomplete="email"
                        :value="contact.email"
                        @input="(event) => updateContactField({field: 'email', value: event.target.value})"
                        class="block w-full rounded-md border-0 px-4 py-2.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                </div>
            </div>
            <div class="sm:col-span-2">
                <label for="telephone" class="block text-md font-bold leading-6 text-gray-900">Phone number</label>
                <div class="mt-2.5">
                    <input
                        type="tel"
                        name="telephone"
                        id="telephone"
                        autocomplete="tel"
                        :value="contact.telephone"
                        @input="(event) => updateContactField({field: 'telephone', value: event.target.value})"
                        class="block w-full rounded-md border-0 px-4 py-2.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                </div>
            </div>
            <div class="sm:col-span-2">
                <label for="message" class="block text-md font-bold leading-6 text-gray-900">Message *</label>
                <div class="mt-2.5">
                    <textarea
                        name="message"
                        id="message"
                        rows="4"
                        :value="contact.message"
                        @input="(event) => updateContactField({field: 'message', value: event.target.value})"
                        class="block w-full rounded-md border-0 px-4 py-2.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    ></textarea>
                </div>
            </div>
            <form-field-re-captcha
                field="recaptcha"
                :onUpdate="updateContactField"
                :error="error"
                :success="success"
            ></form-field-re-captcha>
        </div>
        <div class="mt-10">
            <button-block
                buttonText="Send Message"
                :buttonDisabled="
                    disabled || !contact.first_name || !contact.last_name || !contact.email || !contact.message
                "
                :buttonClick="postContact"
            ></button-block>
            <alert-success class="mt-5" :alert="success" :onDismiss="clearSuccess"></alert-success>
            <alert-error class="mt-5" :alert="error" :onDismiss="clearError"></alert-error>
        </div>
    </form>
</template>

<script>
import {mapState, mapActions} from 'pinia';

export default {
    name: 'FormContact',
    computed: {
        ...mapState(useContactStore, {
            contact: 'contact',
            disabled: 'disabled',
            success: 'success',
            error: 'error',
        }),
    },
    methods: {
        ...mapActions(useContactStore, {
            initContact: 'initContact',
            updateContactField: 'updateContactField',
            postContact: 'postContact',
            clearError: 'clearError',
            clearSuccess: 'clearSuccess',
        }),
    },
    created: function () {
        if (!this.contact) this.initContact();
    },
};
</script>
